"use client";
import Link from "next/link";
import { useParams } from "next/navigation";
import { type ComponentProps } from "react";

export const LinkWithChannel = ({
	href,
	...props
}: Omit<ComponentProps<typeof Link>, "href"> & { href: string }) => {
	const { locale, channel } = useParams<{ locale?: string; channel?: string }>();

	if (!href.startsWith("/")) {
		return <Link {...props} href={href} />;
	}

	const encodedLocale = encodeURIComponent(locale ?? "en");
	const encodedChannel = encodeURIComponent(channel ?? "");
	// "/" means the channel home; emit /{locale}/{channel} without a trailing slash so every
	// page has exactly one URL (GAP-04). Query and fragment stay attached.
	const suffix = href === "/" || href.startsWith("/?") || href.startsWith("/#") ? href.slice(1) : href;
	const hrefWithLocaleAndChannel = `/${encodedLocale}/${encodedChannel}${suffix}`;
	return <Link {...props} href={hrefWithLocaleAndChannel} />;
};
